<template>
  <div class="rt-label-group">
    <el-checkbox-group
      v-bind="$attrs"
      v-model="selectValue"
      @change="handelChange"
    >
      <slot>
        <rt-label-item
          v-for="(item, index) in labelList"
          :label="item[valueKey]"
          :key="index"
        >
          <span>{{ item[nameKey] }}</span>
          <img src="../../assets/imgs/check-circle-fill.png" alt="" />
        </rt-label-item>
      </slot>
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  name: 'RtLabelGroup',
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    }
  },
  data() {
    return {
      selectValue: this.value
    };
  },
  computed: {
    valueKey() {
      return this.alias.valueKey;
    },
    nameKey() {
      return this.alias.nameKey;
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="less">
.rt-label-group {
  .el-checkbox-group {
    display: flex;
    align-items: center;
    .rt-label-item {
      margin-right: 10px;
      .el-checkbox-button {
        .el-checkbox-button__inner {
          padding: 5px 10px;
          font-size: 12px;
          color: #6388c2;
          border: none;
          background: #f5f7fa;
          border-radius: 2px;
          position: relative;

          img {
            display: none;
          }
        }

        &.is-checked {
          .el-checkbox-button__inner {
            background: #1890ff;
            color: #ffffff;

            img {
              display: block;
              width: 12px;
              height: 12px;
              position: absolute;
              right: -4px;
              top: -4px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtLabelGroup.vue?6a5a6c8c